import bookingSpeditorListComponent from './booking-speditor-list.component';

const bookingSpeditorListModule = angular
  .module('bookingSpeditorList', [])
  .component('bookingSpeditorList', bookingSpeditorListComponent);

export default bookingSpeditorListModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-speditor-list/booking-speditor-list.js
 **/